import script from "./contactGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./contactGroup.vue?vue&type=script&setup=true&lang=js"

import "./contactGroup.vue?vue&type=style&index=0&id=62b12dd3&lang=css"

const __exports__ = script;

export default __exports__